import { Box, IconButton } from '@moonpig/launchpad-components'
import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { IconSystemCross } from '@moonpig/launchpad-assets'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'

const StyledCloseButton = styled(IconButton)`
  ${s({
    color: 'colorTextInverted',
  })}
`

const StyledCloseButtonWrapper = styled(Box)`
  position: absolute;
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);

  ${s({
    borderRadius: '50%',
    top: '8px',
    right: { xs: '16px', md: '12px', lg: '20px', xl: '24px', xxl: '38px' },
  })}
`

export const CloseButton: FC = () => {
  const localiseText = useCoreLocaleText()
  return (
    <StyledCloseButtonWrapper>
      <StyledCloseButton
        icon={IconSystemCross}
        label={localiseText('common.close')}
      />
    </StyledCloseButtonWrapper>
  )
}
